export const nameRegex = /^[a-zA-Zа-яА-Я-]{1,15}$/;
export const lastnameRegex = /^[a-zA-Zа-яА-Я-]{1,25}$/;
export const middlenameRegex = /^[a-zA-Zа-яА-Я-]{1,20}$/;
export const passRegex = /^(?=.*\d)(?=.*[a-zA-Z]).{8,100}$/;
